export default __webpack_public_path__ + "static/media/caishen_2_video_updated.01181920.mp4";